import React from 'react';
import PropTypes from 'prop-types';
import DirectoryEntryModel from '../Models/DirectoryEntryModel';
import DetailedEntry from './DetailedEntry';
import axios from '../axios';

class SpecialDirectoryEntry extends React.Component {
    
    constructor (props, context) {
        super(props, context);

        this.state = {
            entry: null
        }; 
    }

    componentWillMount () {
        let prePopulated = window.ICONIC_PRE_PRODUCTS;
        if (prePopulated && prePopulated[this.props.productID]) {
            let entry = new DirectoryEntryModel(prePopulated[this.props.productID]);
            this.setState({ entry });
        } else {
            this.loadEntry();
        }
    }

    /**
     * Loads the selected entry from the API
     */
    async loadEntry () {
        let response = await axios.get(`/directory/${this.props.productID}`);
        let entry = new DirectoryEntryModel(response.data);

        this.setState({ entry });
    }

    render () {
        if (!this.state.entry) {
            return <div></div>;
        }

        return <DetailedEntry entry={ this.state.entry } />;
    }

}

SpecialDirectoryEntry.propTypes = {
    productID: PropTypes.string.isRequired
};

export default SpecialDirectoryEntry;
